<template>
  <div class="search-conversations">
    <div class="search-header">
      <button class="back-btn" type="button" @click="goBack">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </button>
      <div class="search-box">
        <i class="el-icon-search"></i>
        <input
          v-model="searchKeyword"
          type="text"
          placeholder="搜索对话内容"
          ref="searchInput"
        />
        <i v-if="searchKeyword" class="el-icon-circle-close" @click="clearSearch"></i>
      </div>
    </div>

    <div class="search-results" v-loading="loading">
      <div v-if="!searchKeyword" class="hint">
        输入关键词，搜索历史对话内容
      </div>
      <div v-else-if="filteredResults.length === 0" class="no-result">
        暂无搜索结果
      </div>
      <div v-else>
        <div
          v-for="(result, index) in filteredResults"
          :key="result.id || index"
          class="result-item"
          @click="openResult(result)"
        >
          <img :src="result.avatar" class="result-avatar" alt="" />
          <div class="result-content">
            <div class="result-name">{{ result.name }}</div>
            <div class="result-message" v-html="highlightKeyword(result.content)"></div>
          </div>
          <div class="result-date">{{ result.date }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { axios, getDevNo } from '@/config/axios'

export default {
  name: 'StudentSearchConversations',
  data() {
    return {
      searchKeyword: '',
      loading: false,
      messages: [],
      robotAvatar: require('@/assets/img/okaka.png'),
      userAvatar: require('@/assets/img/head.png')
    }
  },
  computed: {
    filteredResults() {
      const keyword = (this.searchKeyword || '').trim()
      if (!keyword) return []
      return this.messages.filter(msg => {
        const content = msg.content || ''
        return content.includes(keyword)
      })
    }
  },
  async mounted() {
    this.$nextTick(() => {
      this.$refs.searchInput && this.$refs.searchInput.focus()
    })
    await this.fetchChatHistory()
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push({ name: 'student-real-time-answers' }).catch(() => {})
      }
    },
    clearSearch() {
      this.searchKeyword = ''
      this.$nextTick(() => {
        this.$refs.searchInput && this.$refs.searchInput.focus()
      })
    },
    highlightKeyword(text) {
      if (!this.searchKeyword || !text) return text || ''
      const keyword = this.searchKeyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      return String(text).replace(
        new RegExp(keyword, 'gi'),
        match => `<span class="highlight">${match}</span>`
      )
    },
    async fetchChatHistory() {
      this.loading = true
      try {
        const devNo = await getDevNo()
        const response = await axios.get('chatHistory', {
          params: {
            pageNumber: 0,
            pageSize: 50,
            devNo
          }
        })

        if (response.data.code === 200 && response.data.data && response.data.data.list) {
          const chatList = [...response.data.data.list].reverse()
          const messages = []

          chatList.forEach(item => {
            const date = item.createTime ? item.createTime.substring(0, 16) : ''
            const time = item.createTime ? item.createTime.substring(11, 16) : ''

            if (item.chatContent) {
              messages.push({
                id: `q-${item.id}`,
                type: 'sent',
                name: '我',
                content: item.chatContent,
                avatar: this.userAvatar,
                date,
                time,
                chatHistoryId: item.id
              })
            }

            if (item.answerContent) {
              const content = this.extractSearchableContent(item.answerContent, item.type)
              if (content) {
                messages.push({
                  id: `a-${item.id}`,
                  type: 'received',
                  name: 'Okaka',
                  content,
                  avatar: this.robotAvatar,
                  date,
                  time,
                  chatHistoryId: item.id
                })
              }
            }
          })

          this.messages = messages
        }
      } catch (error) {
        console.error('获取聊天历史失败:', error)
        this.$message.error('获取聊天历史失败')
      } finally {
        this.loading = false
      }
    },
    extractSearchableContent(answerContent, type) {
      if (!answerContent) return ''
      if (type === 4) return '学习计划 PDF'
      if (type === 5) {
        try {
          const data = typeof answerContent === 'string' ? JSON.parse(answerContent) : answerContent
          if (data && (data.answerStr || data.correctionImgUrl)) {
            return data.answerStr && data.answerStr !== '{}' ? String(data.answerStr) : '作业批改完成'
          }
        } catch (e) {
          /* ignore parse error */
        }
        return '作业批改完成'
      }
      if (type === 3) {
        try {
          const outer = typeof answerContent === 'string' ? JSON.parse(answerContent) : answerContent
          if (outer && outer.answerStr) {
            const inner = typeof outer.answerStr === 'string' ? JSON.parse(outer.answerStr) : outer.answerStr
            if (Array.isArray(inner)) {
              return inner.map(i => i.text || '').filter(Boolean).join(' ') || '错题搜集完成'
            }
          }
        } catch (e) {
          /* ignore parse error */
        }
        return '错题搜集完成'
      }
      if (type === 2) {
        try {
          const data = typeof answerContent === 'string' ? JSON.parse(answerContent) : answerContent
          const parts = [data.ocrContent, data.testPoints, data.preAnswer, data.answer]
            .filter(Boolean)
            .map(String)
          if (parts.length) return parts.join(' ')
        } catch (e) {
          /* ignore parse error */
        }
      }
      return String(answerContent)
    },
    openResult(result) {
      this.$router.push({ name: 'student-real-time-answers' }).then(() => {
        this.$nextTick(() => {
          this.$root.$emit('chat:locate-message', {
            chatHistoryId: result.chatHistoryId,
            content: result.content,
            type: result.type
          })
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.search-conversations {
  width: 100%;
  min-height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-sizing: border-box;
}

.search-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 24px;
  background-color: #fff;
  border-bottom: 1px solid #e8eaed;
  flex-shrink: 0;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 8px 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font-size: 14px;
  color: #5f6368;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  user-select: none;

  i {
    font-size: 16px;
    line-height: 1;
  }

  &:hover {
    background-color: #f0f4f9;
    color: #1a73e8;
  }
}

.search-box {
  flex: 1;
  display: flex;
  align-items: center;
  background-color: #f0f4f9;
  border-radius: 24px;
  padding: 12px 18px;
  gap: 10px;

  .el-icon-search {
    font-size: 18px;
    color: #5f6368;
  }

  input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 15px;
    background: transparent;
    color: #1f1f1f;

    &::placeholder {
      color: #80868b;
    }
  }

  .el-icon-circle-close {
    font-size: 18px;
    color: #5f6368;
    cursor: pointer;

    &:hover {
      color: #1f1f1f;
    }
  }
}

.search-results {
  flex: 1;
  overflow-y: auto;
  background-color: #fff;
}

.hint,
.no-result {
  text-align: center;
  padding: 48px 0;
  color: #8e918f;
  font-size: 14px;
}

.result-item {
  display: flex;
  align-items: center;
  padding: 14px 24px;
  border-bottom: 1px solid #e8eaed;
  cursor: pointer;

  &:hover {
    background-color: #f0f4f9;
  }
}

.result-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  object-fit: cover;
}

.result-content {
  flex: 1;
  min-width: 0;
}

.result-name {
  font-size: 15px;
  color: #1f1f1f;
  margin-bottom: 4px;
}

.result-message {
  font-size: 13px;
  color: #8e918f;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /deep/ .highlight {
    color: #1a73e8;
    font-weight: 500;
  }
}

.result-date {
  font-size: 12px;
  color: #8e918f;
  flex-shrink: 0;
  margin-left: 12px;
}
</style>
